import React, { useState, useEffect, useRef } from "react";
import {
  Box,
  Button,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  VStack,
} from "@chakra-ui/react";
import { ChevronDownIcon } from "@chakra-ui/icons";

const AccountSelect = ({
  options = [],
  onChange,
  selectedId,
  setSelectedId,
  selectedName,
  setSelectedName,
  direction = "right",
}) => {
  const [selected, setSelected] = useState(null);
  const buttonRef = useRef(null);

  useEffect(() => {
    setSelected(selectedId);
  }, [selectedId]);

  const handleSelect = (id, name) => {
    setSelected(id);
    setSelectedId?.(id);
    setSelectedName?.(name);

    const selectedOption = options.find((o) => o.id === id);
    onChange?.(selectedOption);
  };

  const getStyles = (isSelected) => ({
    bg: isSelected ? "#536DEC" : "white",
    color: isSelected ? "white" : "black",
    fontWeight: "normal",
    borderRadius: "8px",
    _hover: {
      color: isSelected ? "white" : "#536DEC",
      bg: isSelected ? "#536DEC" : "white",
    },
    _focus: { bg: isSelected ? "#536DEC" : "white" },
  });

  return (
    <Box position="relative" display="inline-block">
      <Menu
        isLazy
        placement={direction === "left" ? "bottom-start" : "bottom-end"}
        portal={false}
      >
        <MenuButton
          as={Button}
          rightIcon={<ChevronDownIcon />}
          width="auto"
          bg="white"
          color="black"
          border={"1px solid #D1D4DA"}
          _hover={{ bg: "white", border: "1px solid #536DEC" }}
          _expanded={{ bg: "white", border: "1px solid #536DEC" }}
          ref={buttonRef}
        >
          {options.find((o) => o.id === selected)?.name || "All Accounts"}
        </MenuButton>

        <MenuList
          border={"1px solid #D1D4DA"}
          bg="white"
          height="72vh"
          maxH="480px"
          h={"100%"}
          overflowY="auto"
          width="210px"
          minW="unset"
          maxW="170px"
          left="50%"
          transform="translateX(-50%)"
          p={2}
          sx={{
            pr: "5px",
            pl: "5px",
            boxSizing: "content-box",
            "&::-webkit-scrollbar": { width: "8px" },
            "&::-webkit-scrollbar-thumb": {
              background: "#30384A",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-track": {
              background: "gray.100",
              borderRadius: "4px",
              marginBlock: "4px",
            },
          }}
        >
          <VStack align="start" width="100%" spacing={1}>
            <MenuItem
              key={null}
              {...getStyles(selected === null)}
              onClick={() => handleSelect(null, "All Accounts")}
            >
              All Accounts
            </MenuItem>
            {options.map((opt) => {
              const isSelected = selected === opt.id;
              return (
                <MenuItem
                  key={opt.id}
                  {...getStyles(isSelected)}
                  onClick={() => handleSelect(opt.id, opt.name)}
                >
                  {opt.name}
                </MenuItem>
              );
            })}
          </VStack>
        </MenuList>
      </Menu>
    </Box>
  );
};

export default AccountSelect;
